export const BASE_URL = 'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com';

export const IMAGE_PATHS = {
  // BED pages
  BED_LOGO: { path: '/Images/blueearthdiagnosticslogo.png', alt: 'Blue Earth Diagnostics Logo' },
  TRICOLOR_BAR: { path: '/Images/tricoloredbar.png', alt: 'Tri-colored bar' },

  // Home page
  TECH_AND_PATIENT: { path: '/Images/technologist_heroimage.jpg', alt: 'Technologist with patient' },

  // Sign in
  PHYSICIANS_CHATTING: { path: '/Images/physicianschatting.jpg', alt: 'Physicians chatting' },

  // Training list home
  PATIENT_GETTING_SCANNED: { path: '/Images/malegettingscanned.jpg', alt: 'Patient getting scanned' },
  AXUMIN_BUTTON: { path: '/Images/training_icon_axumin.png', alt: 'Axumin logo' },
  POSLUMA_BUTTON: { path: '/Poslumatraining/assets/images/global/POSLUMAStartButton-Bigger.png', alt: 'Posluma logo' },

  // Training overview
  TRAINING_OVERVIEW: {
    '1': {
      PHYSICIANS: {
        path: '/Axumintraining/assets/images/interpretation/imageinterpretationtraining_text.jpg',
        alt: 'Technologists reviewing screen',
      },
      TECHNOLOGISTS: {
        path: '/Axumintraining/assets/images/acquisition/physiciansviewingscreen_purplebox_text.jpg',
        alt: 'Welcome to Image Acquisition Training',
      },
    },
    '2': {
      PHYSICIANS: {
        path: '/Poslumatraining/assets/images/interpretation/Interpretation_Header.png',
        alt: 'Technologists reviewing screen',
      },
      TECHNOLOGISTS: {
        path: '/Poslumatraining/assets/images/acquisition/Acquisition_Header.png',
        alt: 'Welcome to Image Acquisition Training',
      },
    },
  },

  STEPS: {
    // AXUMIN steps
    '1': {
      // Acquisition page 5
      ACQUISITION_STEP_1: {
        path: '/Axumintraining/assets/images/acquisition/step1.png',
        alt: 'Instrumentation for Use with Axumin',
      },
      // Acquisition page 6
      ACQUISITION_STEP_2: {
        path: '/Axumintraining/assets/images/acquisition/step2.png',
        alt: 'Prepare the Patient',
      },
      // Acquisition page 7
      ACQUISITION_STEP_3: {
        path: '/Axumintraining/assets/images/acquisition/step3.png',
        alt: 'Prepare the Axumin Dose',
      },
      // Acquisition page 8-9
      ACQUISITION_STEP_4: {
        path: '/Axumintraining/assets/images/acquisition/step4.png',
        alt: 'Image Acquisition',
      },
      // Acquisition page 10
      ACQUISITION_STEP_5: {
        path: '/Axumintraining/assets/images/acquisition/step5.png',
        alt: 'Image Reconstruction',
      },
      // Interpretation page 10
      INTERPRETATION_STEP_1: {
        path: '/Axumintraining/assets/images/interpretation/step1.png',
        alt: 'Review general interpreation',
      },
      // Interpretation page 11
      INTERPRETATION_STEP_2: {
        path: '/Axumintraining/assets/images/interpretation/step2.png',
        alt: 'Review general interpreation',
      },
      // Interpretation page 12-17
      INTERPRETATION_STEP_3: {
        path: '/Axumintraining/assets/images/interpretation/step3.png',
        alt: 'Access and Evaluate',
      },
      // Interpretation page 18
      INTERPRETATION_STEP_4: {
        path: '/Axumintraining/assets/images/interpretation/step4.png',
        alt: 'Exclude physiological variants',
      },
      // Interpretation page 19
      INTERPRETATION_STEP_5: {
        path: '/Axumintraining/assets/images/interpretation/step5.png',
        alt: 'Create Interpreation Report',
      },
    },
    // POSLUMA steps
    '2': {
      // Acquisition page 5
      ACQUISITION_STEP_1: {
        path: '/Poslumatraining/assets/images/acquisition/Step1.png',
        alt: 'STEP 1-5 panel, STEP 1',
      },
      // Acquisition page 6
      ACQUISITION_STEP_2: {
        path: '/Poslumatraining/assets/images/acquisition/Step2.png',
        alt: 'STEP 1-5 panel, STEP 2',
      },
      // Acquisition page 7
      ACQUISITION_STEP_3: {
        path: '/Poslumatraining/assets/images/acquisition/Step3.png',
        alt: 'STEP 1-5 panel, STEP 3',
      },
      // Acquisition page 8
      ACQUISITION_STEP_4: {
        path: '/Poslumatraining/assets/images/acquisition/Step4.png',
        alt: 'STEP 1-5 panel, STEP 4',
      },
      // Acquisition page 9
      ACQUISITION_STEP_5: {
        path: '/Poslumatraining/assets/images/acquisition/Step5.png',
        alt: 'STEP 1-5 panel, STEP 5',
      },
      // Interpretation page 11
      INTERPRETATION_STEP_1: {
        path: '/Poslumatraining/assets/images/interpretation/Step1.png',
        alt: 'STEP 1-3 panel, STEP 1',
      },
      // Interpretation page 12-13
      INTERPRETATION_STEP_2: {
        path: '/Poslumatraining/assets/images/interpretation/Step2.png',
        alt: 'STEP 1-3 panel, STEP 2',
      },
      // Interpretation page 14
      INTERPRETATION_STEP_3: {
        path: '/Poslumatraining/assets/images/interpretation/Step3.png',
        alt: 'STEP 1-3 panel, STEP 3',
      },
    },
  },

  // Training pages
  TRAINING_PAGES: {
    '1': {
      LOGO: { path: '/Axumintraining/assets/images/global/axuminlogo2.png', alt: 'Axumin logo' },
      NAVIGATION_ARROW: { path: '/Axumintraining/assets/images/interpretation/navbar.png', alt: 'Navigation arrow' },
      EXPAND_ICON: { path: '/Axumintraining/assets/images/global/grayexpand_button.png', alt: 'ISI Expand' },
      CONTRACT_ICON: { path: '/Axumintraining/assets/images/global/button_minus_black.png', alt: 'Black close dash' },
      INDICATION: {
        path: '/Axumintraining/assets/images/global/axuminindicationgraph.jpg',
        alt: 'Axumin Indication',
      },
    },
    '2': {
      LOGO: { path: '/Poslumatraining/assets/images/global/posluma_logo_new.png', alt: 'Posluma logo' },
      NAVIGATION_ARROW: {
        path: '/Poslumatraining/assets/images/global/navbar_arrow_blue.png',
        alt: 'Navigation arrow',
      },
      EXPAND_ICON: { path: '/Axumintraining/assets/images/global/grayexpand_button.png', alt: 'ISI Expand' },
      CONTRACT_ICON: { path: '/Axumintraining/assets/images/global/button_minus_black.png', alt: 'Black close dash' },
      INDICATION: {
        path: '/Axumintraining/assets/images/global/axuminindicationgraph.jpg',
        alt: 'Axumin Indication',
      },
    },
  },
  // Axumin Acquisition Page 8 / Interpretation Page 6
  PROPER_POSITIONING: {
    path: '/Axumintraining/assets/images/global/properpositioning.png',
    alt: 'Position the patient timeline',
  },
  // Axumin Interpretation Page 3
  BIODISTRIBUTION: {
    path: '/Axumintraining/assets/videos/global/trackactivitychart_part2.gif',
    alt: 'Biodistribution GIF',
  },
  DOSING_TIMELINE: {
    path: '/Axumintraining/assets/images/global/dosingadmintimeline.jpg',
    alt: 'Dose admin acq timeline',
  },
  IMAGE_ACQ_TIME: {
    path: '/Axumintraining/assets/images/acquisition/imageacquisition_time.jpg',
    alt: 'How to capture scan in purple',
  },
  IMAGE_ACQ_TIME2: {
    path: '/Axumintraining/assets/images/acquisition/imageacquisition_time_cont.jpg',
    alt: 'How to capture scan in yellow',
  },
  AXUMIN_IMAGE_ACQ_CLIP: {
    path: '/Axumintraining/assets/images/acquisition/imagereconstructionclipboard_text.jpg',
    alt: 'Image reconstruction',
  },
  POSLUMA_IMAGE_ACQ_CLIP: {
    path: '/Poslumatraining/assets/images/acquisition/step5_clipboard.png',
    alt: 'Steps for improved image reconstruction',
  },
  CHECKMARK: {
    path: '/Axumintraining/assets/images/global/icon_checkmark_purple.png',
    alt: 'Purple check',
  },
  YELLOW_CHECKMARK: {
    path: '/Axumintraining/assets/images/global/checkmarkincircle.png',
    alt: 'Check',
  },
  BLUE_CHECKMARK: {
    path: '/Poslumatraining/assets/images/global/checkmark_blue.png',
    alt: 'Blue check',
  },

  // Axumin home
  HOME_PAGE: {
    '1': {
      WELCOME_IMAGE: {
        path: '/Axumintraining/assets/images/global/physicianwearingglasses_purplebox_text_v3.png',
        alt: 'Physician looking forward',
      },
      IMAGE_ACQUISITION_ICON: {
        path: '/Axumintraining/assets/images/global/acquisition_icon.png',
        alt: 'Image acquisition icon',
      },
      IMAGE_ACQUISITION_THUMBNAIL: {
        path: '/Axumintraining/assets/images/global/acquisition_thumbnail.jpg',
        alt: 'Image aquisition thumbnail',
      },
      IMAGE_INTERPRETATION_ICON: {
        path: '/Axumintraining/assets/images/global/interpretation_icon.png',
        alt: 'Image interpretation icon',
      },
      IMAGE_INTERPRETATION_THUMBNAIL: {
        path: '/Axumintraining/assets/images/global/interpretation_thumbnail.jpg',
        alt: 'Image interpretation thumbnail',
      },
    },
    '2': {
      WELCOME_IMAGE: {
        path: '/Poslumatraining/assets/images/global/welcome_image.png',
        alt: 'Patient looking forward',
      },
      IMAGE_ACQUISITION_ICON: {
        path: '/Poslumatraining/assets/images/global/acquisition_icon.png',
        alt: 'PET scan',
      },
      IMAGE_ACQUISITION_THUMBNAIL: {
        path: '/Poslumatraining/assets/images/global/acquisition_thumbnail_v2.png',
        alt: 'Image aquisition thumbnail',
      },
      IMAGE_INTERPRETATION_ICON: {
        path: '/Poslumatraining/assets/images/global/interpretation_icon.png',
        alt: 'Health care professional clipboard',
      },
      IMAGE_INTERPRETATION_THUMBNAIL: {
        path: '/Poslumatraining/assets/images/global/interpretation_thumbnail_v2.png',
        alt: 'Image interpretation thumbnail',
      },
    },
  },

  // Learning Check Questions
  LEARNING_CHECK_ICONS: {
    '1': {
      LEARNING_CHECK_ICON: {
        path: '/Axumintraining/assets/images/global/learningcheckquestions_icon_transparent%402x.png',
        alt: 'Learning check icon',
      },
    },
    '2': {
      LEARNING_CHECK_ICON: {
        path: '/Poslumatraining/assets/images/global/learningcheck_questions_icon.png',
        alt: 'Learning check icon',
      },
    },
  },

  // Downloadable Resources
  AXUMIN_DOWNLOADABLE_RESOURCES_ICON: {
    path: '/Axumintraining/assets/images/global/downloadableresources_icon.png',
    alt: 'Downloadable resources',
  },
  // Downloadable Resources
  POSLUMA_DOWNLOADABLE_RESOURCES_ICON: {
    path: '/Poslumatraining/assets/images/global/downloadableresources_icon.png',
    alt: 'File download',
  },
  AXUMIN_PDF_RESOURCES_ICON: {
    path: '/Axumintraining/assets/images/global/pdficon.png',
    alt: 'Downloadable resources',
  },
  POSLUMA_PDF_RESOURCES_ICON: {
    path: '/Poslumatraining/assets/images/global/pdf_download_icon.png',
    alt: 'Downloadable resources',
  },

  CASE_STUDY: {
    '1': {
      // Case Study - Axumin
      CASE_STUDY_ICON: {
        path: '/Axumintraining/assets/images/global/casestudy_profileicon.png',
        alt: 'case study icon',
      },
      CASE_STUDY_HEADSHOT_1: {
        path: '/Axumintraining/assets/images/acquisition/casestudy1_headshot.png',
        alt: 'image of male',
      },
      CASE_STUDY_HEADSHOT_2: {
        path: '/Axumintraining/assets/images/interpretation/casestudy2_headshot.png',
        alt: 'image of male',
      },
      CASE_STUDY_HEADSHOT_3: {
        path: '/Axumintraining/assets/images/interpretation/casestudy3_headshot.png',
        alt: 'image of male',
      },
      CASE_STUDY_HEADSHOT_4: {
        path: '/Axumintraining/assets/images/interpretation/casestudy4_headshot.png',
        alt: 'image of male',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_1: {
        path: '/Axumintraining/assets/images/global/additionalcases1.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_2: {
        path: '/Axumintraining/assets/images/global/additionalcases2.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_3: {
        path: '/Axumintraining/assets/images/global/additionalcases3.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_4: {
        path: '/Axumintraining/assets/images/global/additionalcases4.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_5: {
        path: '/Axumintraining/assets/images/global/additionalcases5.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_6: {
        path: '/Axumintraining/assets/images/global/additionalcases6.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_1: {
        path: '/Axumintraining/assets/images/acquisition/CaseStudy1imaging.png',
        alt: 'PET/CT Images',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_2: {
        path: '/Axumintraining/assets/images/acquisition/CaseStudy2imaging.png',
        alt: 'PET/CT Images',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_3: {
        path: '/Axumintraining/assets/images/acquisition/CaseStudy3imaging.png',
        alt: 'PET/CT Images',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_4: {
        path: '/Axumintraining/assets/images/acquisition/CaseStudy4imaging.png',
        alt: 'PET/CT Images',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_5: {
        path: '/Axumintraining/assets/images/acquisition/CaseStudy5imaging.png',
        alt: 'PET/CT Images',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_6: {
        path: '/Axumintraining/assets/images/acquisition/CaseStudy6imaging.png',
        alt: 'PET/CT Images',
      },
      CASE_STUDY_TAB_1: {
        path: '/Axumintraining/assets/images/global/tabs_presentation.png',
        alt: 'Presentation tab',
      },
      CASE_STUDY_TAB_2: {
        path: '/Axumintraining/assets/images/global/tabs_imaging.png',
        alt: 'Imaging tab',
      },
      CASE_STUDY_TAB_3: {
        path: '/Axumintraining/assets/images/global/tabs_findings.png',
        alt: 'Findings tab',
      },
      CASE_STUDY_TAB_1_IMAGE: {
        path: '/Axumintraining/assets/images/global/clinicalhistory_icon.png',
        alt: 'Clinical history icon',
      },
      CASE_STUDY_TAB_3_IMAGE: {
        path: '/Axumintraining/assets/images/global/imagingfindings_icon.png',
        alt: 'Image findings icon',
      },
      CASE_STUDY_NEXT_ENABLED: {
        path: '/Axumintraining/assets/images/global/nextarrow_active.png',
        alt: 'Next',
      },
      CASE_STUDY_NEXT_DISABLED: {
        path: '/Axumintraining/assets/images/global/nextarrow_inactive.png',
        alt: 'Next (disabled)',
      },
      CASE_STUDY_PREVIOUS_ENABLED: {
        path: '/Axumintraining/assets/images/global/backarrow_active.png',
        alt: 'Previous',
      },
      CASE_STUDY_PREVIOUS_DISABLED: {
        path: '/Axumintraining/assets/images/global/backarrow_inactive.png',
        alt: 'Previous (disabled)',
      },
    },
    '2': {
      // Case Study - POSLUMA
      CASE_STUDY_ICON: {
        path: '/Poslumatraining/assets/images/global/casestudy_profileicon.png',
        alt: 'case study icon',
      },
      CASE_STUDY_HEADSHOT_1: {
        path: '/Poslumatraining/assets/images/global/casestudy1_headshot.png',
        alt: 'image of male',
      },
      CASE_STUDY_HEADSHOT_2: {
        path: '/Poslumatraining/assets/images/global/casestudy2_headshot.png',
        alt: 'image of male',
      },
      CASE_STUDY_HEADSHOT_3: {
        path: '/Poslumatraining/assets/images/global/casestudy3_headshot.png',
        alt: 'image of male',
      },
      CASE_STUDY_HEADSHOT_4: {
        path: '/Poslumatraining/assets/images/global/casestudy4_headshot.png',
        alt: 'image of male',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_1: {
        path: '/Poslumatraining/assets/images/global/casestudy1_headshot.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_2: {
        path: '/Poslumatraining/assets/images/global/casestudy2_headshot.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_3: {
        path: '/Poslumatraining/assets/images/global/casestudy3_headshot.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_4: {
        path: '/Poslumatraining/assets/images/global/casestudy4_headshot.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_5: {
        path: '/Poslumatraining/assets/images/global/casestudy5_headshot.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_HEADSHOT_6: {
        path: '/Poslumatraining/assets/images/global/casestudy6_headshot.png',
        alt: 'Male patient ',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_1: {
        path: '/Poslumatraining/assets/images/global/CaseStudy1imaging_v2.png',
        alt: 'POSLUMA Images prostate tumor',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_2: {
        path: '/Poslumatraining/assets/images/global/CaseStudy2imaging_v2.png',
        alt: 'POSLUMA Images multifocal primary prostate cancer',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_3: {
        path: '/Poslumatraining/assets/images/global/CaseStudy3imaging_v2.png',
        alt: 'POSLUMA Images retroperitoneal lymph nodes',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_4: {
        path: '/Poslumatraining/assets/images/global/CaseStudy4imaging_v2.png',
        alt: 'POSLUMA Images spine and rib',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_5: {
        path: '/Poslumatraining/assets/images/global/CaseStudy5imaging_v2.png',
        alt: 'POSLUMA Images prostate beds',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_6: {
        path: '/Poslumatraining/assets/images/global/CaseStudy6imaging_v2.png',
        alt: 'POSLUMA Images pelvic lymph node',
      },
      ADDITIONAL_CASE_STUDY_IMAGING_6_AXUMIN: {
        path: '/Poslumatraining/assets/images/global/CaseStudy6imaging_Axumin_v2.png',
        alt: 'Axumin Images pelvic lymph node',
      },
      CASE_STUDY_TAB_1: {
        path: '/Poslumatraining/assets/images/global/tabs_presentation.png',
        alt: 'Presentation tab',
      },
      CASE_STUDY_TAB_2: {
        path: '/Poslumatraining/assets/images/global/tabs_imaging.png',
        alt: 'Imaging tab',
      },
      CASE_STUDY_TAB_3: {
        path: '/Poslumatraining/assets/images/global/tabs_findings.png',
        alt: 'Findings tab',
      },
      CASE_STUDY_TAB_1_IMAGE: {
        path: '/Poslumatraining/assets/images/global/patientpresentation_icon.png',
        alt: 'Patient presentation icon',
      },
      CASE_STUDY_TAB_3_IMAGE: {
        path: '/Poslumatraining/assets/images/global/imagingfindings_icon.png',
        alt: 'Image findings icon',
      },
      CASE_STUDY_NEXT_ENABLED: {
        path: '/Poslumatraining/assets/images/global/nextarrow_active.png',
        alt: 'Next',
      },
      CASE_STUDY_NEXT_DISABLED: {
        path: '/Poslumatraining/assets/images/global/nextarrow_inactive.png',
        alt: 'Next (disabled)',
      },
      CASE_STUDY_PREVIOUS_ENABLED: {
        path: '/Poslumatraining/assets/images/global/backarrow_active.png',
        alt: 'Previous',
      },
      CASE_STUDY_PREVIOUS_DISABLED: {
        path: '/Poslumatraining/assets/images/global/backarrow_inactive.png',
        alt: 'Previous (disabled)',
      },
    },
  },

  ADDITIONAL_CASE_STUDIES: {
    '1': {
      MAIN_IMAGE: {
        path: '/Poslumatraining/assets/images/global/1001118.png',
        alt: '',
      },
      MAIN_PET: {
        path: '/Poslumatraining/Axial_PT_Slice_227-Enhanced 1001118.jpg',
        alt: '',
      },
      MAIN_FUSED: {
        path: '/Poslumatraining/Axial_FUS_Slice_227-Enhanced 1001118.jpg',
        alt: '',
      },
      MAIN_CT: {
        path: '/Poslumatraining/Axial_CT_Slice_227-Enhanced 1001118.jpg',
        alt: '',
      },
      EXTRAPELVIC_PET: {
        path: '/Poslumatraining/Coronal_PT_5.47_mm-Enhanced 1001118.jpg',
        alt: '',
      },
      EXTRAPELVIC_FUSED: {
        path: '/Poslumatraining/Coronal_FUS_5.47_mm-Enhanced 1001118.jpg',
        alt: '',
      },
      EXTRAPELVIC_CT: {
        path: '/Poslumatraining/Coronal_CT_5.47_mm-Enhanced 1001118.jpg',
        alt: '',
      },
      MULTIPLE_BONE_LESIONS_SIDE_PET: {
        path: '/Poslumatraining/Sagittal_PT_7.95_mm-Enhanced 1001118.jpg',
        alt: '',
      },
      MULTIPLE_BONE_LESIONS_SIDE_FUS: {
        path: '/Poslumatraining/Sagittal_FUS_7.95_mm-Enhanced 1001118.jpg',
        alt: '',
      },
      MULTIPLE_BONE_LESIONS_SIDE_CT: {
        path: '/Poslumatraining/Sagittal_CT_7.95_mm-Enhanced 1001118.jpg',
        alt: '',
      },
      MULTIPLE_BONE_LESIONS_FRONT_PET: {
        path: '/Poslumatraining/Coronal_PT_62.31_mm-Enhanced 1001118.jpg',
        alt: '',
      },
      MULTIPLE_BONE_LESIONS_FRONT_FUS: {
        path: '/Poslumatraining/Coronal_FUS_62.31_mm-Enhanced 1001118.jpg',
        alt: '',
      },
      MULTIPLE_BONE_LESIONS_FRONT_CT: {
        path: '/Poslumatraining/Coronal_CT_62.31_mm-Enhanced 1001118.jpg',
        alt: '',
      },
    },
    '2': {
      MAIN_IMAGE: {
        path: '/Poslumatraining/assets/images/global/1002212.png',
        alt: '',
      },
      AXIAL_CT: {
        path: '/Poslumatraining/Axial_CT_Slice_126-Enhanced 2002101.jpg',
        alt: '',
      },
      AXIAL_FUS: {
        path: '/Poslumatraining/Axial_FUS_Slice_126-Enhanced 2002101.jpg',
        alt: '',
      },
      AXIAL_CT2: {
        path: '/Poslumatraining/Axial_CT_Slice_145-Enhanced 2002101.jpg',
        alt: '',
      },
      AXIAL_FUS2: {
        path: '/Poslumatraining/Axial_FUS_Slice_145-Enhanced 2002101.jpg',
        alt: '',
      },
      AXIAL_PET: {
        path: '/Poslumatraining/Axial_PT_Slice_63-Enhanced 2002101.jpg',
        alt: '',
      },
      AXIAL_PET2: {
        path: '/Poslumatraining/Axial_PT_Slice_44-Enhanced 2002101.jpg',
        alt: '',
      },
    },
    '3': {
      MAIN_IMAGE: {
        path: '/Poslumatraining/assets/images/global/1002224.png',
        alt: '',
      },
      CORONAL_RETRO_LYMPTH_NODES_CT: {
        path: '/Poslumatraining/Coronal_CT_2.73_mm-Enhanced 1002224.jpg',
        alt: '',
      },
      CORONAL_RETRO_LYMPTH_NODES_FUS: {
        path: '/Poslumatraining/Coronal_FUS_2.73_mm-Enhanced 1002224.jpg',
        alt: '',
      },
      CORONAL_RETRO_LYMPTH_NODES_PET: {
        path: '/Poslumatraining/Coronal_PT_2.73_mm-Enhanced 1002224.jpg',
        alt: '',
      },
      AXIAL_RETRO_LYMPTH_NODES_CT: {
        path: '/Poslumatraining/Axial_CT_Slice_177-Enhanced 102224.jpg',
        alt: '',
      },
      AXIAL_RETRO_LYMPTH_NODES_FUS: {
        path: '/Poslumatraining/Axial_FUS_Slice_177-Enhanced 1002224.jpg',
        alt: '',
      },
      AXIAL_RETRO_LYMPTH_NODES_PET: {
        path: '/Poslumatraining/Axial_PT_Slice_177-Enhanced 1002224.jpg',
        alt: '',
      },
      AXIAL_PT_FINDINGS_1: {
        path: '/Poslumatraining/Axial_PT_Slice_236(1)-Findings 1002224.jpg',
        alt: '',
      },
      AXIAL_PT_FINDINGS_2: {
        path: '/Poslumatraining/Axial_PT_Slice_177-Findings 1002224.jpg',
        alt: '',
      },
      AXIAL_FUS_FINDINGS_1: {
        path: '/Poslumatraining/Axial_FUS_Slice_236(1)-Findings 1002224.jpg',
        alt: '',
      },
      AXIAL_FUS_FINDINGS_2: {
        path: '/Poslumatraining/Axial_FUS_Slice_177-Findings 1002224.jpg',
        alt: '',
      },
      FINDINGS_COMBINED: {
        path: '/Poslumatraining/assets/images/global/v2-1002224-Comparison-arrows.png',
        alt: '',
      },
    },
    '4': {
      MAIN_IMAGE: {
        path: '/Poslumatraining/assets/images/global/1002237.png',
        alt: '',
      },
      VERTEBRAL_LESION_CT: {
        path: '/Poslumatraining/Axial_CT_Slice_82 1002237.jpg',
        alt: '',
      },
      VERTEBRAL_LESION_FUS: {
        path: '/Poslumatraining/Axial_FUS_Slice_82 1002237.jpg',
        alt: '',
      },
      VERTEBRAL_LESION_PET: {
        path: '/Poslumatraining/Axial_PT_Slice_82 1002237.jpg',
        alt: '',
      },
      AXIAL_CT: {
        path: '/Poslumatraining/Axial_CT_Slice_132 1002237.jpg',
        alt: '',
      },
      AXIAL_FUS: {
        path: '/Poslumatraining/Axial_FUS_Slice_132 1002237.jpg',
        alt: '',
      },
      AXIAL_PET: {
        path: '/Poslumatraining/Axial_PT_Slice_132 1002237.jpg',
        alt: '',
      },
      AXIAL_FINDINGS_1: {
        path: '/Poslumatraining/Axial_FUS_Slice_132 findings 1002237.jpg',
        alt: '',
      },
      AXIAL_FINDINGS_2: {
        path: '/Poslumatraining/Axial_FUS_Slice_159 Findings 1002237.jpg',
        alt: '',
      },
      FINDINGS_COMBINED: {
        path: '/Poslumatraining/assets/images/global/v2-1002237-Comparison-v2.png',
        alt: '',
      },
    },
    '5': {
      MAIN_IMAGE: {
        path: '/Poslumatraining/assets/images/global/1007205.png',
        alt: '',
      },
      AXIAL_CT: {
        path: '/Poslumatraining/Axial_CT_Slice_223-Enhanced 1007205.jpg',
        alt: '',
      },
      AXIAL_FUS: {
        path: '/Poslumatraining/Axial_FUS_Slice_223-Enhanced 1007205.jpg',
        alt: '',
      },
      AXIAL_PET: {
        path: '/Poslumatraining/Axial_PT_Slice_223-Enhanced 1007205.jpg',
        alt: '',
      },
      AXIAL_CT2: {
        path: '/Poslumatraining/Axial_CT_Slice_208-Enhanced 1007205.jpg',
        alt: '',
      },
      AXIAL_FUS2: {
        path: '/Poslumatraining/Axial_FUS_Slice_208-Enhanced 1007205.jpg',
        alt: '',
      },
      AXIAL_PET2: {
        path: '/Poslumatraining/Axial_PT_Slice_208-Enhanced 1007205.jpg',
        alt: '',
      },
      AXIAL_CT3: {
        path: '/Poslumatraining/Axial_CT_Slice_191-Enhanced 1007205.jpg',
        alt: '',
      },
      AXIAL_FUS3: {
        path: '/Poslumatraining/Axial_FUS_Slice_191-Enhanced 1007205.jpg',
        alt: '',
      },
      AXIAL_PET3: {
        path: '/Poslumatraining/Axial_PT_Slice_191-Enhanced 1007205.jpg',
        alt: '',
      },
      AXIAL_FINDINGS_1: {
        path: '/Poslumatraining/Sagittal_FUS_-0.85_mm-1007205 findings.jpg',
        alt: '',
      },
      AXIAL_FINDINGS_2: {
        path: '/Poslumatraining/Sagittal_FUS_10.35_mm-findings 1007205.jpg',
        alt: '',
      },
      FINDINGS_COMBINED: {
        path: '/Poslumatraining/assets/images/global/v2-1007205-Comparison-v2.png',
        alt: '',
      },
    },
    '6': {
      MAIN_IMAGE: {
        path: '/Poslumatraining/assets/images/global/1017228.png',
        alt: '',
      },
      AXIAL_CT: {
        path: '/Poslumatraining/Axial_CT_Slice_199-Enhanced 1017228.jpg',
        alt: '',
      },
      AXIAL_FUS: {
        path: '/Poslumatraining/Axial_FUS_Slice_199-Enhanced 1017228.jpg',
        alt: '',
      },
      AXIAL_PET: {
        path: '/Poslumatraining/Axial_PT_Slice_199-Enhanced 1017228.jpg',
        alt: '',
      },
      AXIAL_CT2: {
        path: '/Poslumatraining/Axial_CT_Slice_267-Enhanced 1017228.jpg',
        alt: '',
      },
      AXIAL_FUS2: {
        path: '/Poslumatraining/Axial_FUS_Slice_267-Enhanced 1017228.jpg',
        alt: '',
      },
      AXIAL_PET2: {
        path: '/Poslumatraining/Axial_PT_Slice_267-Enhanced 1017228.jpg',
        alt: '',
      },
      AXIAL_FINDINGS_1: {
        path: '/Poslumatraining/Axial_FUS_Slice_187-Findings 1017228.jpg',
        alt: '',
      },
      AXIAL_FINDINGS_2: {
        path: '/Poslumatraining/Axial_FUS_Slice_199-Findings 1017228.jpg',
        alt: '',
      },
      FINDINGS_COMBINED: {
        path: '/Poslumatraining/assets/images/global/v2-1017228-Comparison-v2.png',
        alt: '',
      },
    },
  },

  // POSLUMA Acquisition page 3
  IMAGING_THERAPY: {
    path: '/Poslumatraining/assets/images/acquisition/Imaging-Therapy-Image.png',
    alt: 'POSLUMA radiohybrid with labeling',
  },
  POSLUMA_CHEMICAL_STRUCTURE: {
    path: '/Poslumatraining/assets/images/acquisition/POSLUMA_chemical_structure.jpg',
    alt: 'POSLUMA chemical structure',
  },
  HEALTHY_VOLUNTEER_PET: {
    path: '/Poslumatraining/assets/images/acquisition/healthy_volunteer_pet.png',
    alt: 'POSLUMA PET images of healthy volunteer',
  },
  // POSLUMA Acquisition page 6
  HYDRATION_ICON: {
    path: '/Poslumatraining/assets/images/acquisition/hydration_icon_posluma.png',
    alt: 'Hydration prior to administration',
  },
  POSLUMA_VOID_ICON: {
    path: '/Poslumatraining/assets/images/acquisition/void_icon_posluma.png',
    alt: 'Hydration and voiding following administration',
  },
  // POSLUMA Acquisition page 7
  POSLUMA_PREPARE_DOSE_TIMELINE: {
    path: '/Poslumatraining/assets/images/acquisition/prepare_dose_timeline_posluma.png',
    alt: 'Hydration and voiding following administration',
  },
  // POSLUMA Acquisition page 8
  START_IMAGE: {
    path: '/Poslumatraining/assets/images/acquisition/Acquisition-Start-Image.png',
    alt: 'Acquisition timeline and patient positioning following administration with labeling',
  },
  INJECTION_TIMELINE: {
    path: '/Poslumatraining/assets/images/acquisition/acquisition_injection_timeline.png',
    alt: 'Dosage, administration, and acquisition timeline',
  },

  // POSLUMA Interpretation page 12
  PROSTATE_BED: {
    path: '/Poslumatraining/assets/images/interpretation/prostate_and_prostate_bed_v2.png',
    alt: 'PET images—prostate and prostate bed',
  },
  PROSTATE_BED_2: {
    path: '/Poslumatraining/assets/images/interpretation/prostate_and_prostate_bed_2_v2.png',
    alt: 'PET images—prostate and prostate bed',
  },
  LYMPHATIC_DRAINAGE_SITES: {
    path: '/Poslumatraining/assets/images/interpretation/Primarylymphaticdrainagesitesoftheprostate.png',
    alt: 'Primary lymphatic drainage sites of the prostate',
  },
  PELVIC_GANGLIA_PET: {
    path: '/Poslumatraining/assets/images/interpretation/pelvic_ganglia_pet.png',
    alt: 'Uptake in sacral ganglion',
  },
  PELVIC_GANGLIA_PET_ARROWS: {
    path: '/Poslumatraining/assets/images/interpretation/UptakeInSacralGanglion_v2.png',
    alt: 'Uptake in sacral ganglion',
  },
  // POSLUMA Interpretation page 13
  CELIAC_GANGLIA_ANATOMY: {
    path: '/Poslumatraining/assets/images/interpretation/Anatomyoftheceliacandsacralganglia.png',
    alt: 'Anatomy of the celiac and sacral ganglia',
  },
  ANTERIOR_VIEW_OF_GANGLIA: {
    path: '/Poslumatraining/assets/images/interpretation/Anteriorviewofcervicalganglia.png',
    alt: 'Anterior and lateral view of cervical ganglia',
  },
  LATERAL_VIEW_OF_GANGLIA: {
    path: '/Poslumatraining/assets/images/interpretation/Lateralviewofcervicalganglia.png',
    alt: 'Anterior and lateral view of cervical ganglia',
  },
  VIRCHOW_PET_ARROWS: {
    path: '/Poslumatraining/assets/images/interpretation/UptakeInVirchowNode_v2.png',
    alt: 'POSLUMA uptake in Virchow node',
  },
  VIRCHOW_PET: {
    path: '/Poslumatraining/assets/images/interpretation/1021204_Virchow_FUS_PET_ax_cor.png',
    alt: 'POSLUMA uptake in Virchow node',
  },
  MEDIASTINAL_AND_HILAR_LYMPH_NODES: {
    path: '/Poslumatraining/assets/images/interpretation/POSLUMAUptakemediastinalandhilarlymphnodes.png',
    alt: 'POSLUMA uptake in Virchow node',
  },
  MEDIASTINAL_AND_HILAR_LYMPH_NODES_ARROWS: {
    path: '/Poslumatraining/assets/images/interpretation/POSLUMAUptakemediastinalandhilarlymphnodesArrows_v2.png',
    alt: 'POSLUMA uptake in Virchow node',
  },
  // POSLUMA Interpretation page 14
  CERVICAL_GANGLION_BLUE_ARROWS: {
    path: '/Poslumatraining/assets/images/interpretation/Cervicalganglion-bluearrows.png',
    alt: 'Cervical ganglion-blue arrows',
  },
  LYMPTH_NODES: {
    path: '/Poslumatraining/assets/images/interpretation/bilateral_inguinal_lympth_nodes.png',
    alt: 'Bilateral and inguinal lymph nodes',
  },
  LYMPTH_NODES_ARROWS: {
    path: '/Poslumatraining/assets/images/interpretation/PhysiologicAxiallaandInguinalArrows.png',
    alt: 'Bilateral and inguinal lymph nodes',
  },

  // Interpretation page 3
  MOLECULAR_STRUCTURE: {
    path: '/Axumintraining/assets/videos/global/AxuminMolecularStructure.gif',
    alt: 'Molecular structure GIF',
  },
  BIODISTRIBUTION_GRAPH: {
    path: '/Axumintraining/assets/videos/global/trackactivitychart.gif',
    alt: 'Biodistribution graph GIF',
  },
  BIODISTRIBUTION_GRAPH_PART2: {
    path: '/Axumintraining/assets/videos/global/trackactivitychart_part2.gif',
    alt: 'Biodistribution graph GIF',
  },

  // Interpretation page 4 & POSLUMA Acquisition Page 5
  YES_CHECK: {
    path: '/Axumintraining/assets/images/global/step1yes.png',
    alt: 'Yes check',
  },
  NO_X: {
    path: '/Axumintraining/assets/images/global/step1no.png',
    alt: 'Red X',
  },

  // Interpretation page 5
  EXERCISE_ICON: {
    path: '/Axumintraining/assets/images/interpretation/icon_exercise%402x.png',
    alt: 'Exercise icon',
  },
  EATING_ICON: {
    path: '/Axumintraining/assets/images/interpretation/icon_eating%402x.png',
    alt: 'Eating icon',
  },
  VOID_ICON: {
    path: '/Axumintraining/assets/images/interpretation/icon_void%402x.png',
    alt: 'Void icon',
  },
  PREPARE_DOSE_TIMELINE: {
    path: '/Axumintraining/assets/images/global/prepdoseadmin_graph.png',
    alt: 'Prepare dose vertical timeline',
  },
  STATIS_VEIN: {
    path: '/Axumintraining/assets/images/global/stasis_axillary_vein.jpg',
    alt: 'Stasis in axillary vein',
  },
  VIRCHOWS_NODE: {
    path: '/Axumintraining/assets/images/global/virchows_node.jpg',
    alt: "Virchow's node",
  },

  // Interpretation page 9
  BLOOD_POOL_DIAGRAM: {
    path: '/Axumintraining/assets/images/interpretation/interest_for_blood_pool.jpg',
    alt: 'Aorta',
  },
  BONE_MARROW_DIAGRAM: {
    path: '/Axumintraining/assets/images/interpretation/step1_bonemarrow.jpg',
    alt: 'Bone marrow',
  },

  PET_WINDOW_DISPLAY_GUIDELINES: {
    path: '/Axumintraining/assets/images/interpretation/petguidelines.jpg',
    alt: 'PET Window Display Guidelines',
  },

  // Interpretation page 12
  PROSTATE_TABLE: {
    path: '/Axumintraining/assets/images/interpretation/prostatebedtable.png',
    alt: 'Prostate Bed: Post-Prostatectomy',
  },
  ELEVATED_CORONAL: {
    path: '/Axumintraining/assets/images/interpretation/elevatedpsa_coronal43.5.png',
    alt: 'Coronal view',
  },
  ELEVATED_SAGITAL: {
    path: '/Axumintraining/assets/images/interpretation/elevatedpsa_sagital43.5.png',
    alt: 'Sagital view',
  },
  ELEVATED_CORONAL_29: {
    path: '/Axumintraining/assets/images/interpretation/elevatedpsa_coronal.29.png',
    alt: 'Coronal view',
  },
  SAGITAL_VIEW: {
    path: '/Axumintraining/assets/images/interpretation/sagitalview_step3.1.png',
    alt: 'Sagital view',
  },
  MILD_BLADDER_ACTIVITY: {
    path: '/Axumintraining/assets/images/interpretation/mildbladderactivity.jpg',
    alt: 'Mild bladder activity',
  },
  SAGITTAL_VIEW_STEP_3: {
    path: '/Axumintraining/assets/images/interpretation/sagittalview_step3.jpg',
    alt: 'Sagital view',
  },
  SAGITTAL_VIEW_STEP_3_ARROWS: {
    path: '/Axumintraining/assets/images/interpretation/sagittalview_step3_arrows.jpg',
    alt: 'Sagital view',
  },
  PROSTATE_BED_TABLE: {
    path: '/Axumintraining/assets/images/interpretation/prostatebedtable2.png',
    alt: 'Prostate table',
  },
  AXIAL_VIEW_STEP_3_ARROWS: {
    path: '/Axumintraining/assets/images/interpretation/axialview_step3_arrow.jpg',
    alt: 'axial view',
  },
  AXIAL_VIEW_SINGLE: {
    path: '/Axumintraining/assets/images/interpretation/axialviewsingle_step3.jpg',
    alt: 'Axial view',
  },
  CORONAL_VIEW_STEP_3_ARROWS: {
    path: '/Axumintraining/assets/images/interpretation/coronalview_step3_arrow.jpg',
    alt: 'Coronal view ',
  },
  BIOPSY_MALIGNANT: {
    path: '/Axumintraining/assets/images/interpretation/biopsy_malignant.jpg',
    alt: 'Positive prostate, biopsy proven malignant',
  },
  STEP_3_CORONAL: {
    path: '/Axumintraining/assets/images/interpretation/step3_coronal.jpg',
    alt: 'Cranial view',
  },
  STEP_3_SAGITAL: {
    path: '/Axumintraining/assets/images/interpretation/sagittal_view.jpg',
    alt: 'Sagital view',
  },
  STEP_3_CORONAL_ARROW: {
    path: '/Axumintraining/assets/images/interpretation/coronal_view_findings.jpg',
    alt: 'coronal view ',
  },
  STEP_3_SAGITAL_ARROW: {
    path: '/Axumintraining/assets/images/interpretation/step3_sagitalview.jpg',
    alt: 'Sagital view',
  },

  // Interpretation page 14
  VESTICLES: {
    path: '/Axumintraining/assets/images/interpretation/step3_seminalvesicles.jpg',
    alt: 'Seminal Vesicle',
  },

  // Interpretation page 15
  CRANIAL_CAUDAL_STACKVIEW: {
    path: '/Axumintraining/assets/images/interpretation/Cranial_caudal_stackview.jpg',
    alt: 'Cranial caudal view',
  },
  CRANIAL_CAUDAL_FINDINGS: {
    path: '/Axumintraining/assets/images/interpretation/cranial_caudal_view_findings.jpg',
    alt: 'Cranial caudal view',
  },
  CRANIAL_CAUDAL_ARROWS: {
    path: '/Axumintraining/assets/images/interpretation/cranial_caudal_view_arrows.jpg',
    alt: 'Cranial caudal view with points',
  },
  CORONAL_VIEW_3: {
    path: '/Axumintraining/assets/images/interpretation/coronal_view3.jpg',
    alt: 'Coronal view',
  },
  SAGITTAL_VIEW_4: {
    path: '/Axumintraining/assets/images/interpretation/sagittal_view4.jpg',
    alt: 'Sagital view',
  },
  FINDINGS_AXIAL_2: {
    path: '/Axumintraining/assets/images/interpretation/findings_axial2.jpg',
    alt: 'Axial view',
  },
  FINDINGS_CORONAL: {
    path: '/Axumintraining/assets/images/interpretation/findings_coronal.jpg',
    alt: 'Coronal view',
  },
  REVIEW_AXIAL_2: {
    path: '/Axumintraining/assets/images/interpretation/review_axial2.jpg',
    alt: 'Axial view',
  },
  FINDINGS_AXIAL_3: {
    path: '/Axumintraining/assets/images/interpretation/findings_axial1.jpg',
    alt: 'Axial view',
  },
  TABLE_LYMPHNODES: {
    path: '/Axumintraining/assets/images/interpretation/table_lymphnodes.png',
    alt: 'Lymph nodes',
  },
  CHART_LEFT: {
    path: '/Axumintraining/assets/images/interpretation/chart_left.png',
    alt: 'Chart',
  },
  CHART_RIGHT: {
    path: '/Axumintraining/assets/images/interpretation/chart_right.png',
    alt: 'Chart',
  },
  CORONAL_VIEW_4: {
    path: '/Axumintraining/assets/images/interpretation/coronalviewstep3.4.jpg',
    alt: 'Coronal view',
  },
  AXIAL_VIEW: {
    path: '/Axumintraining/assets/images/interpretation/axialview.jpg',
    alt: 'axial view',
  },
  CORONAL_VIEW_STEP_3: {
    path: '/Axumintraining/assets/images/interpretation/coronalview-step3.jpg',
    alt: 'Coronal view',
  },
  // Interpretation page 16
  CRANIAL_CAUDAL_VIEW: {
    path: '/Axumintraining/assets/images/interpretation/cranialtocaudal.jpg',
    alt: 'Cranial to caudal view',
  },
  CRANIAL_CAUDAL_VIEW_2: {
    path: '/Axumintraining/assets/images/interpretation/cranialtocaudal2.jpg',
    alt: 'Cranial to caudal view 2',
  },
  CRANIAL_CAUDAL_VIEW_3: {
    path: '/Axumintraining/assets/images/interpretation/cranialtocaudal3.jpg',
    alt: 'Cranial to caudal view 3',
  },
  AXIAL_VIEW_1: {
    path: '/Axumintraining/assets/images/interpretation/axialview_arrows.jpg',
    alt: 'Axial view',
  },
  // Interpretation page 17
  MILD_BLADDER: {
    path: '/Axumintraining/assets/images/interpretation/mildbladderactivity.jpg',
    alt: 'Mild bladder activity',
  },
  SIGNIFICANT_BLADDER: {
    path: '/Axumintraining/assets/images/interpretation/significantbladderactivity.jpg',
    alt: 'Significant ballder activity',
  },
  COMPARISON_CHART: {
    path: '/Axumintraining/assets/images/interpretation/comparison_chartstep3.png',
    alt: 'Differing tumors from inflammation',
  },
  OSTEIODOSTEOMA: {
    path: '/Axumintraining/assets/images/interpretation/osteiodosteoma.jpg',
    alt: 'Osteoid Osteoma',
  },
  RINGWORM: {
    path: '/Axumintraining/assets/images/interpretation/ringworm.jpg',
    alt: 'Ringworm',
  },
  MENINGIOMA: {
    path: '/Axumintraining/assets/images/interpretation/meningioma.jpg',
    alt: 'Meningioma',
  },
  PROSTATITIS: {
    path: '/Axumintraining/assets/images/interpretation/prostatitis.jpg',
    alt: 'prostatasis',
  },
  ARTICLE_CLIP: {
    path: '/Axumintraining/assets/images/interpretation/articleclip.jpg',
    alt: 'Clipping',
  },
  TUBULOVILLOUSADENOMA: {
    path: '/Axumintraining/assets/images/interpretation/tubulovillousadenoma_step4.jpg',
    alt: 'Incidental non-physiologic uptake can occur',
  },
  BENIGN_PROSTATIC: {
    path: '/Axumintraining/assets/images/interpretation/benignprostatic_step4.jpg',
    alt: 'Benign prostatic hyperplasia',
  },

  // Acquisition Case study 1
  PET_CORONAL: {
    path: '/Axumintraining/assets/images/acquisition/retroperitonealmalignantnodes.jpg',
    alt: 'PET coronal',
  },
  PET_CT_TRANSAXIAL: {
    path: '/Axumintraining/assets/images/acquisition/nodesstacked.jpg',
    alt: 'PET/CT TRANSAXIAL',
  },
  // Acquisition Case study 2
  POSITIVE_VERTEBRATE: {
    path: '/Axumintraining/assets/images/acquisition/positivevertebrate.jpg',
    alt: 'Positive vertebrate',
  },
  POSITIVE_PROSTATE: {
    path: '/Axumintraining/assets/images/acquisition/positiveprostate.jpg',
    alt: 'Positive prostate',
  },
  // Acquisition Case study 3
  BONE_LEFT_ILIUM_UPTAKE: {
    path: '/Axumintraining/assets/images/acquisition/boneleftiliumuptake.jpg',
    alt: 'Bone left ilium uptake',
  },
  RIGHT_INTERNAL_ILLIAC: {
    path: '/Axumintraining/assets/images/acquisition/rightinternal%2Billiacnode.jpg',
    alt: 'Right internal illiac node',
  },
  // Image Acquisition
  FIRST_BED_POSITION: {
    path: '/Axumintraining/assets/images/acquisition/learningcheckanswer_bedposition.png',
    alt: 'First bed position',
  },
  // Acquisition Drag and Drop
  DRAG_DROP_A4: {
    path: '/Axumintraining/assets/images/global/dragdrop_A4.png',
    alt: 'Should administer',
  },
  DRAG_DROP_A5: {
    path: '/Axumintraining/assets/images/global/dragdrop_A5.png',
    alt: 'Arms down',
  },
  DRAG_DROP_A2: {
    path: '/Axumintraining/assets/images/global/dragdrop_A2.png',
    alt: 'After administration',
  },
  DRAG_DROP_ANSWERS: {
    // path: '/Axumintraining/assets/images/acquisition/dragdropanswers.png',
    path: '/Axumintraining/assets/images/acquisition/draganddropanswers.jpg',
    alt: 'DRAG and DROP ANSWERS',
  },

  // Acquisition Case Study
  LEFT_INTERNAL: {
    path: '/Axumintraining/assets/images/acquisition/leftinternalillian_stacked.jpg',
    alt: 'Left internal iliac lymph node uptake',
  },
  BONE_RIGHT: {
    path: '/Axumintraining/assets/images/acquisition/bonerightiliumintake.jpg',
    alt: 'Bone right ilium uptake',
  },

  // MIP Label
  SUV: {
    path: '/Axumintraining/assets/images/global/suv.png',
    alt: 'SUV',
  },
};

// VIMEO VIDEO LINKS
export const VIDEO_PATHS = {
  // Acquisition Case Studies
  MECHANICS_OF_ACTION: {
    path: 'https://vimeo.com/878795276',
  },
  ACQ_CASE_STUDY_1: {
    path: 'https://vimeo.com/647808555',
  },
  ACQ_CASE_STUDY_2: {
    path: 'https://vimeo.com/647808578',
  },
  ACQ_CASE_STUDY_3: {
    path: 'https://vimeo.com/647808598',
  },
  ACQ_CASE_STUDY_4: {
    path: 'https://vimeo.com/647808604',
  },

  // Interpretation Case Studies
  INT_CASE_STUDY_1: {
    path: 'https://vimeo.com/638769120',
  },
  INT_CASE_STUDY_2: {
    path: 'https://vimeo.com/638755612',
  },
  INT_CASE_STUDY_3: {
    path: 'https://vimeo.com/638767659',
  },
  INT_CASE_STUDY_4: {
    path: 'https://vimeo.com/638775140',
  },

  // Misc Videos
  MOA: {
    path: 'https://vimeo.com/638776840',
  },
  BIO: {
    path: 'https://vimeo.com/638739939',
  },
  LYMPH: {
    path: 'https://vimeo.com/638776135',
  },
  FOCAL_UPTAKE: {
    path: 'https://vimeo.com/638755471',
  },
  // POSLUMA Interpretation page 11
  INTERPRETATION_AVI: {
    path: 'https://vimeo.com/805165324',
  },
  // POSLUMA Acquisition page 3
  POSLUMA_UPTAKE_AVI: {
    path: 'https://vimeo.com/805165273',
  },

  // POSLUMA Interpretation case studies
  CASE_STUDY_1: {
    path: 'https://vimeo.com/813000733',
  },
  CASE_STUDY_2: {
    path: 'https://vimeo.com/813003890',
  },
  CASE_STUDY_3: {
    path: 'https://vimeo.com/813003929',
  },
  CASE_STUDY_4: {
    path: 'https://vimeo.com/813009017',
  },

  // ADDITIONAL CASE STUDIES
  // 1001118
  ACS_1: {
    path: 'https://vimeo.com/807154157',
  },
  // 2002101
  ACS_2: {
    path: 'https://vimeo.com/807154221',
  },
  // 1002224
  ACS_3: {
    path: 'https://vimeo.com/807154172',
  },
  // 1002237
  ACS_4: {
    path: 'https://vimeo.com/807154186',
  },
  // 1007205
  ACS_5: {
    path: 'https://vimeo.com/807154208',
  },
  // 1007228
  ACS_6: {
    path: 'https://vimeo.com/807154213',
  },
};

// DOCUMENT PATHS
export const DOCUMENT_PATHS = {
  '1': {
    INTERPRETATION_COMPLETE: {
      path: '/Axumintraining/assets/pdfs/Statement_of_Completion_Interpretation_Training.pdf',
    },
    ACQUISITION_COMPLETE: {
      path: '/Axumintraining/assets/pdfs/Statement_of_Completion_AcquisitionTraining.pdf',
    },
  },
  '2': {
    INTERPRETATION_COMPLETE: {
      path: '/Poslumatraining/assets/pdfs/Statement_of_Completion_Interpretation_Training.pdf',
    },
    ACQUISITION_COMPLETE: {
      path: '/Poslumatraining/assets/pdfs/Statement_of_Completion_AcquisitionTraining.pdf',
    },
  },
};
